import domQueries from '../../../__env__/domQueries';
import {ifUndefined} from "../../utils/js";

/**
 *
 * @return {Element}
 */
function getLayoutElement() {
    return ifUndefined(domQueries.layoutElement, function () {
        return document.body;
    })();
}

/**
 *
 * @return {Element}
 */
function getLayoutPortalElement() {
    return ifUndefined(domQueries.layoutPortalElement, function () {
        return document.body;
    })();
}

/**
 *
 * @return {Element|null}
 */
function getLayoutHeader() {
    return ifUndefined(domQueries.layoutHeader, function () {
        return null;
    })();
}

/**
 *
 * @return {Element|null}
 */
function getLayoutScrollElement() {
    return ifUndefined(domQueries.layoutScrollElement, function () {
        return null;
    })();
}

/**
 *
 * @return {Element|Window}
 */
function getLayoutScrollObject() {
    return getLayoutScrollElement() || window;
}

export {
    getLayoutElement,
    getLayoutPortalElement,
    getLayoutHeader,
    getLayoutScrollElement,
    getLayoutScrollObject,
}
